/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  CellType,
  ComponentType,
  IMediaModel,
  IPersonModel,
  Orientation,
} from "@nf/common";
import { isServerSideRender } from "@nf/helpers";
import { useTranslation } from "next-i18next";
import { GridComponent, ListComponentPersonItemFrame } from "../../components";

import styles from "./PersonScreen.module.scss";

export interface PersonScreenProps {
  person?: IPersonModel;
  personMediaList: IMediaModel[];
}

export const PersonScreen = ({
  person,
  personMediaList,
}: PersonScreenProps) => {
  const { t } = useTranslation("translations");

  // FIXME For some actors/directors this page crashes when rendered on the server
  if (isServerSideRender) {
    return null;
  }

  if (!person) {
    return (
      <div className={styles.container}>
        <p className={styles.noResults}>{t("web_search_no_result_text")}</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.person}>
        {/** TODO list component is typed for media elements only
         * it might be a good idea to make it more generic so
         * other data such as person could be used */}
        {/* @ts-ignore */}
        <ListComponentPersonItemFrame media={person} isActive={true} />
      </div>

      <h2>
        {t("web_search_results_movies_selected", {
          name: person.PersonFullName,
        })}
      </h2>

      {personMediaList && (
        <GridComponent
          columns={3}
          dynamicHeight
          dataLength={personMediaList.length}
          component={{
            ComponentTypeCode: ComponentType.List,
            CellType: CellType.Frame,
            Orientation: Orientation.Grid,
            MediaList: personMediaList,
          }}
        />
      )}
    </div>
  );
};

export default PersonScreen;
